import TextEditor from '../../components/textEditor/TextEditor'

const TutorAgreement = () => {
    return (
        <TextEditor tag_name="tutor_agreement" />
    )
}

export default TutorAgreement